import { render, staticRenderFns } from "./roasterStyle.vue?vue&type=template&id=f0595d1a&"
import script from "./roasterStyle.vue?vue&type=script&lang=js&"
export * from "./roasterStyle.vue?vue&type=script&lang=js&"
import style0 from "./roasterStyle.vue?vue&type=style&index=0&id=f0595d1a&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports